/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Toggle_FiltersInputs */

const en_editor_toggle_filters = /** @type {(inputs: Editor_Toggle_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle event filters`)
};

const fr_editor_toggle_filters = /** @type {(inputs: Editor_Toggle_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer les filtres d'evenements`)
};

const de_editor_toggle_filters = /** @type {(inputs: Editor_Toggle_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisfilter umschalten`)
};

const it_editor_toggle_filters = /** @type {(inputs: Editor_Toggle_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva i filtri degli eventi`)
};

const ru_editor_toggle_filters = /** @type {(inputs: Editor_Toggle_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить фильтры событий`)
};

const es_editor_toggle_filters = /** @type {(inputs: Editor_Toggle_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar o desactivar filtros de eventos`)
};

const zh_cn2_editor_toggle_filters = /** @type {(inputs: Editor_Toggle_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换事件筛选器`)
};

const ja_editor_toggle_filters = /** @type {(inputs: Editor_Toggle_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントフィルターを切り替える`)
};

const hi_editor_toggle_filters = /** @type {(inputs: Editor_Toggle_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट फ़िल्टर को टॉगल करें`)
};

const pt_pt2_editor_toggle_filters = /** @type {(inputs: Editor_Toggle_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar filtros de eventos`)
};

/**
* | output |
* | --- |
* | "Toggle event filters" |
*
* @param {Editor_Toggle_FiltersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_toggle_filters = /** @type {((inputs?: Editor_Toggle_FiltersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Toggle_FiltersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_toggle_filters(inputs)
	if (locale === "de") return de_editor_toggle_filters(inputs)
	if (locale === "it") return it_editor_toggle_filters(inputs)
	if (locale === "ru") return ru_editor_toggle_filters(inputs)
	if (locale === "es") return es_editor_toggle_filters(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_toggle_filters(inputs)
	if (locale === "ja") return ja_editor_toggle_filters(inputs)
	if (locale === "hi") return hi_editor_toggle_filters(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_toggle_filters(inputs)
	return en_editor_toggle_filters(inputs)
});